import {
    trigger,
    AnimationTriggerMetadata, state, style, transition, animate, keyframes,
} from '@angular/animations';
/** Набор анимаций для кнопки прокрутки вверх */
export const scrollToTopAnimations: {
    readonly showHide: AnimationTriggerMetadata;
} = {
    showHide: trigger('showHide', [
        state('hide', style({ display: 'none' })),
        state('show', style({ display: 'block' })),
        transition('hide => show', animate(
            '0.5s',
            keyframes([
                style({ opacity: 0, display: 'block', offset: 0 }),
                style({ opacity: 0.5, display: 'block', offset: 0.5 }),
                style({ opacity: 1, display: 'block', offset: 1 }),
            ])
        )),
        transition('show => hide', animate(
            '0.5s',
            keyframes([
                style({ opacity: 1, offset: 0 }),
                style({ opacity: 0.5, offset: 0.5 }),
                style({ opacity: 0, offset: 1 }),
            ])
        ))
    ])
};

